export const buildRequestEmployeeMetrcKey = (userApiKey, enabled) => {
  const request = {
    data: {
      type: 'compliance_employees',
      attributes: {
        credentials: [
          {
            complianceType: 'METRC',
            clientSecret: userApiKey,
            enabled
          },
        ],
      },
    },
  }
  return request
}



// WEBPACK FOOTER //
// ./src/utils/requestEmployeeMetrcKey.js